var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.background)},[_c('div',{staticClass:"homeWelcome"},[_vm._v(" 欢迎使用学生视力分析平台 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }